// 类型
export enum Types {
    '线上直充' = 1,
    '电子券',
    '甜蜜兑',
}
//模块
export enum Modules {
    '线上直充' = 1,
    '电子券',
    '甜蜜兑',
}
//品牌模式
export enum Brands {
    '卡劵' =1,
    '甜蜜兑'
}
//充值方式
export enum WayTypes {
    '自制'=1,
    '采购'
}
//发票类型
export enum InvoiceType {
    '未设置',
    '专票',
    '普票',
    '无票',
    '其他',
}
//电子券发票类型
export enum InvoiceELectron {
    '未设置',
    '专票纸质版',
    '专票电子版',
    '普票纸质版',
    '普票电子版',
    '无票',
    '其他',
}
//订单类型
export enum OrderTypes {
    '未支付',
    '待使用',
    '已完成',
    '已退单'
}
//图片类型
export enum ProductTypes {
    '全部',
    '商品图片',
    '详情图'
}
// 对接类型
export enum InterfaceTypes {
    'API对接' = 1,
    'H5对接',
    '特殊对接'
}
